import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { PermissionProvider } from "./permissionContext";
import App from "./App";

ReactDOM.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <PermissionProvider>
      <App />
    </PermissionProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
